import { Injectable } from '@angular/core';
import { IID_EP_SUPPORT } from '@common/interfaces/interfaceData';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IIDepGisfoSupportQuery } from './iidEPGisfoSupport.query';
import { IIDepGisfoSupportStore } from './iidEPGisfoSupport.store';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.SUPPORT)
export class IIDepGisfoSupportService extends CrudService<IID_EP_SUPPORT, IIDepGisfoSupportStore, IIDepGisfoSupportQuery> {
  constructor(
    protected store: IIDepGisfoSupportStore,
    public query: IIDepGisfoSupportQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
  ) {
    super(
      Topics.IID_EP_GISFO_SUPPORT,
      store,
      query,
      actionService,
      updateStrategy
    );
  }

}
